// app/services/project-header.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import config from '../../../../../auth_config.json';
import { StoreService } from './store.service';

export const projectHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  // Clone the request and inject the mandatory multi-tenant boundary header
  const projectBoundApis = [
    config.fmedaApiUri,
    //config.geometriesUri,
    //config.windingUri,
    //config.apiUri,
    //config.visUri
  ].filter(uri => !!uri);

  // Check if the outgoing request URL starts with any of the project bound microservices
  const isProjectBoundRequest = projectBoundApis.some(apiUri => req.url.startsWith(apiUri));
  // Conditionally attach the X-Project-ID context header
  if (isProjectBoundRequest) {
    // Use the currently selected project context, falling back to the demo project.
    const currentProjectId = inject(StoreService).currentProject()?.id || 'dummyproject';

    const clonedReq = req.clone({
      headers: req.headers.set('X-Project-ID', currentProjectId)
    });

    return next(clonedReq);
  }

  //  If it does not need the x-project header or is WebSocket endpoint, or external asset request, pass it through completely untouched
  return next(req);
};